@if (user) {
  <td [routerLink]="['/medecin/' + user.id + '/patient/list']" tuiTd>
    {{ user.id }}
  </td>

  <td [routerLink]="['/medecin/' + user.id + '/patient/list']" tuiTd>
    {{ user.nom }} {{ user.prenom }}
  </td>

  <td [routerLink]="['/medecin/' + user.id + '/patient/list']" tuiTd>
    {{ user.username }}
  </td>

  <td [routerLink]="['/medecin/' + user.id + '/patient/list']" tuiTd>
    {{ user.role?.name }}
  </td>

  @if (
    authService.user?.role?.slug == "super-admin" ||
    authService.user?.role?.slug == "admin" ||
    (authService.user?.autorisations?.get("edit")?.length ?? 0) > 1
  ) {
    <td tuiTd>
      @if (
        authService.user?.role?.slug == "super-admin" ||
        authService.user?.role?.slug == "admin" ||
        authService.user?.autorisations?.get("edit")?.includes(user.id)
      ) {
        <button
          size="s"
          appearance="outline"
          [routerLink]="['/profil', user.id]"
          tuiButton
        >
          Modifier mot de passe
        </button>
      }
    </td>
  }
  @if (authService.user?.role?.slug == "super-admin") {
    <td tuiTd>
      @if (user.actif) {
        <button
          size="s"
          appearance="outline"
          (click)="switchActif(false)"
          tuiButton
        >
          Désactiver
        </button>
      } @else {
        <button
          size="s"
          appearance="accent"
          (click)="switchActif(true)"
          tuiButton
        >
          Réactiver
        </button>
      }
    </td>
  }
} @else {
  <td tuiTd class="placeholder">000</td>

  <td tuiTd></td>

  <td tuiTd></td>
}
